<template>
  <div class="set-avatar bg-background" :class="{ invisible: isCameraActive }">
    <Header>
      プロフィール写真
    </Header>
    <div class="pt-2 pb-4 mx-3">
      <StepBar :maxValue="4" :currentValue="1" class="mb-4" />
      <SetAvatar
        v-model="inputValues"
        v-model:isCameraActive="isCameraActive"
      />
      <BottomFormActionButtons @submit="onClickSubmit" hideSkipButton />
    </div>
    <BlockBack />
  </div>
</template>

<script lang="ts">
import { accountService } from "@/app/services/AccountService";
import StepBar from "@/components/molecules/other/StepBar.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import Header from "@/components/organisms/common/Header.vue";
import BottomFormActionButtons from "@/components/organisms/register/BottomFormActionButtons.vue";
import SetAvatar from "@/components/organisms/register/SetAvatar.vue";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import { authStore } from "@/store/auth";
import { AvatarInputValues } from "@/types/user/RequestVerificationQueueBody";
import { routerPush } from "@/utils/routerPush";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { Component, Vue } from "vue-facing-decorator";

@Component({
  components: {
    Header,
    BlockBack,
    BottomFormActionButtons,
    StepBar,
    SetAvatar
  }
})
export default class RegisterSetAvatar extends Vue {
  inputValues: AvatarInputValues = {
    avatar: null
  };

  isCameraActive = false;

  async created() {
    this.$loading.show();
    try {
      const userData = await accountService.fetchUserData();
      // ページを戻るなどで初回認証送信後にこのページに遷移した場合、強制的にマイページにリダイレクトする
      if (userData.hasRegisteredProfile) {
        await routerPush(this, { name: "Mypage" });
        return;
      }
    } catch (err) {
      await showErrorModal(this, err as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  async onClickSubmit() {
    if (!this.inputValues.avatar) {
      this.$bvModal.msgBoxOk(
        "プロフィール写真を撮影、またはファイル選択してください",
        {
          centered: true
        }
      );
      return;
    }
    try {
      this.$loading.show();
      const body = {
        avatar: this.inputValues.avatar,
        hasRegisteredAvatar: true
      };
      await authStore.registerUserInfo(body);
      sendAdjustEvent("FINISH_INPUT_AVATAR_IMAGE");
      sendFirebaseCustomEvent("finish_input_avatar_image", {
        session_id: authStore.sessionId || "unknown"
      });
      await routerPush(this, { name: "RegisterSetId" });
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }
}
</script>

<style lang="scss" scoped>
.set-avatar {
  min-height: inherit;
}
</style>
